import { Flex, HStack, Icon, IconButton, LinkBox, LinkOverlay, ListItem, Text } from "@chakra-ui/react"
import format from "date-fns/format"
import React, { useMemo, useState } from "react"
import { X } from "react-feather"
import { NavLink } from "react-router-dom"
import { IBeaconFragment, useMeQuery } from "../../graphql"
import { checkForPermissions } from "../../utils"
import { Stat } from "../common"

export type IBeaconListItemProps = {
	ibeacon: IBeaconFragment
	zoneId?: string
}

export const IBeaconListItem: React.FC<IBeaconListItemProps> = ({ ibeacon, zoneId }) => {
	const [isHovered, setIsHovered] = useState(false)

	const [{ data: meData }] = useMeQuery()

	const canRemoveIBeacon = useMemo(() => {
		return checkForPermissions(meData?.me, "ibeacons/remove-ibeacon-from-zone")[0]
	}, [meData?.me])

	return (
		<ListItem as={LinkBox} _hover={{ bgColor: "blackAlpha.100" }} transition="background-color .1s ease-in" rounded="xl" cursor="pointer" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
			<LinkOverlay as={NavLink} to={`/ibeacons/${ibeacon._id}`} />
			<HStack w="full" justify="space-between" px="2">
				<Flex flex="1" justify="center" align="center" flexWrap="wrap">
					<Stat label="Name" value={ibeacon.label.name} />
					<Stat label="UUID" value={ibeacon.uuid} />
					<Stat label="Major / Minor" value={`${ibeacon.major} / ${ibeacon.minor}`} />
					<Stat label="TX Power" value={`${ibeacon.txPower} dBm`} />
					<Stat label="Status" value={ibeacon.assignedToZoneId ? <Text color="success.600">Assigned</Text> : <Text color="error.600">Unassigned</Text>} />
					{ibeacon.assignedAt && <Stat label="Assigned At" value={format(new Date(ibeacon.assignedAt), "MMM dd, yyyy HH:mm")} />}
				</Flex>
				{canRemoveIBeacon && zoneId && isHovered && (
					<IconButton aria-label="remove-ibeacon-from-zone-btn" as={NavLink} to={`/zones/${zoneId}/ibeacons/${ibeacon._id}/remove`} colorScheme="error" size="xs">
						<Icon as={X} />
					</IconButton>
				)}
			</HStack>
		</ListItem>
	)
}
